module.exports = __webpack_public_path__ + "img/SC-7999.22220294.png";